"use client";

import React from "react";
import { Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-muted rounded-sm animate-pulse" />
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3 text-sm text-muted-foreground font-sans">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="hover:text-secondary transition-colors duration-200">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const serviceAreas = ["Des Moines", "West Des Moines", "Ankeny", "Urbandale", "Waukee", "Johnston"];
  return <footer data-section-id="162793" id="footer" className="dark bg-primary text-foreground border-t border-border/20 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-secondary/5 via-primary to-primary pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          
          {}
          <div className="flex flex-col items-start">
            <Link to="#" className="inline-block mb-6">
              
            </Link>
            <p className="text-muted-foreground text-sm mb-8 leading-relaxed font-sans">
              Connecting Des Moines homeowners with trusted local crawl-space professionals
            </p>
          </div>

          {}
          <div>
            <h3 className="font-sans text-lg font-bold mb-6 text-foreground tracking-tight">
              Navigation
            </h3>
            <MenuProvider menu_id="45">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-sans text-lg font-bold mb-6 text-foreground tracking-tight">
              Service Areas
            </h3>
            <ul className="space-y-3 text-sm text-muted-foreground font-sans">
              {serviceAreas.map((area, i) => <li key={i} data-index={i} className="flex items-center gap-2">
                  <div className="size-1 bg-secondary/50 rounded-lg" />
                  {area}
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-sans text-lg font-bold mb-6 text-foreground tracking-tight">
              Contact Us
            </h3>
            
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-sm bg-secondary/10 border border-secondary/20 mb-6">
              <span className="relative flex size-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-lg bg-secondary opacity-75"></span>
                <span className="relative inline-flex rounded-lg size-2 bg-secondary"></span>
              </span>
              <span className="text-xs font-mono font-medium text-secondary uppercase tracking-wider">
                In Des Moines Now
              </span>
            </div>

            <ul className="space-y-4 text-sm text-muted-foreground font-sans">
              <li className="flex items-center gap-3 group">
                <Phone className="size-5 shrink-0 text-secondary group-hover:scale-110 transition-transform" />
                <Link to="tel:5155859542" className="hover:text-foreground transition-colors">(515) 585-9542</Link>
              </li>
            </ul>
          </div>

        </div>

        {}
        <div className="pt-8 border-t border-border/20 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-muted-foreground font-mono">
          <p>© 2026&nbsp;Des Moines Crawlspace Referral Service. All rights reserved.</p>
          <p>Serving Des Moines, IA and surrounding areas.</p>
          <div className="flex gap-4">
            <Link to="#" className="hover:text-foreground transition-colors">Terms of Use</Link>
            <Link to="#" className="hover:text-foreground transition-colors">Lead Generation Disclosure</Link>
          </div>
        </div>
      </div>
    </footer>;
}